exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.document-content[data-v-29fef2da]:not(:last-child) {\n  border-bottom: 1px solid #e6e6e6;\n}\n.document-content__title[data-v-29fef2da] {\n  font-weight: 500;\n}\n.document-content__type[data-v-29fef2da] {\n  font-style: italic;\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/containers/block/components/block-apartment-documents/styles.scss"],"names":[],"mappings":";AAAA;EAEI,iCAAgC;CACjC;AACD;EACE,iBAAgB;CACjB;AACD;EACE,mBAAkB;CACnB","file":"styles.scss","sourcesContent":[".document-content {\n  &:not(:last-child) {\n    border-bottom: 1px solid #e6e6e6;\n  }\n  &__title {\n    font-weight: 500;\n  }\n  &__type {\n    font-style: italic;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29fef2da","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/containers/block/components/block-apartment-documents/styles.scss
// module id = APdz
// module chunks = 0